import { parseJsonSafe } from '../../utils/json/parseJsonSafe';

export const getSessionUserData = () => parseJsonSafe(sessionStorage.getItem('USER_DATA'));
